import { render, staticRenderFns } from "./vs-form-radio.vue?vue&type=template&id=64a35a15&scoped=true"
import script from "./vs-form-radio.vue?vue&type=script&lang=js"
export * from "./vs-form-radio.vue?vue&type=script&lang=js"
import style0 from "./vs-form-radio.vue?vue&type=style&index=0&id=64a35a15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a35a15",
  null
  
)

export default component.exports